<template>
    <div>
        <div class="columns">
            <div class="column is-2"><span class="is-size-7">{{link.name}}</span></div>
            <div class="column is-4"><span class="is-size-7">{{link.url}}</span></div>
            <div class="column is-4"><span class="is-size-7">{{link.image}}</span></div>
            <div class="column is-2">
                <div class="field has-addons">
                    <p class="control">
                        <button @click="editMe()" class="button is-small">
                            <span class="icon is-small">
                                <i class="fas fa-pen"></i>
                            </span>
                        </button>
                    </p>
                    <p @click="addChildLink()" class="control">
                        <button class="button is-small is-info">
                            <span class="icon is-small">
                                <i class="fas fa-plus"></i>
                                <i class="fas fa-link"></i>
                            </span>
                        </button>
                    </p>
                    <p v-if="remove" @click="removeMe()" class="control">
                        <button class="button is-small is-danger">
                            <span class="icon is-small">
                                <i class="fas fa-trash-alt"></i>
                            </span>
                        </button>
                    </p>
                </div>
            </div>
        </div>
        <template v-if="link.links && link.links.length">
            <div v-for="(l, i) in link.links" :key="l.id" class="columns">
                <div class="column is-1">
                </div>
                <div class="column is-11">
                    <link-info
                        :link="l"
                        :edit="(el) => editChildLink(el)"
                        :remove="() => removeChildLink(i)"
                    />
                </div>
            </div>
        </template>
    </div>
</template>
<script>
import Vue from 'vue';

export default {
    name: 'content-link-info',
    props: {
        link: {
            type: Object,
            required: true
        },
        edit: {
            type: Function,
            required: true
        },
        remove: {
            type: Function
        }
    },
    data() {
        return {
            childLinksIndex: 0
        };
    },
    created() {
        let i = 1;
        if (this.link.links && this.link.links.length) {
            this.link.links.forEach(l => (l.id = i++));
        }
        this.childLinksIndex = i;
    },
    methods: {
        editMe() {
            this.edit(this.link);
        },
        removeMe() {
            if (confirm(`Are you sure you want to delete link '${this.link.name}'?`)) {
                this.remove();
            }
        },
        addChildLink() {
            if (!this.link.links) {
                Vue.set(this.link, 'links', []);
            }
            this.link.links.push({ id: this.childLinksIndex++, name: '' });
        },
        editChildLink(l) {
            this.edit(l);
        },
        removeChildLink(index) {
            this.link.links.splice(index, 1);
        }
    }
};
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// front/src/components/common/content/link/link-info.vue